/*
 ** HOC
 */

var withRouter = function withRouter(component, key) {
  var routedComponent = component;
  routedComponent.key = key;
  return routedComponent;
};
export default withRouter;